import richTextUtils from "../../utils/richtext.utils";
import DOMUtils from "@utils/dom.utils";

export default function (editor) {
  const SELECTOR = "input.fill-in-box";
  const richTextEditor = editor.options.get("richTextEditor");
  const disableFibBlank = richTextEditor.disableFibBlank;

  editor.ui.registry.addButton("fib_blank", {
    tooltip: "Add Blank",
    text: "Add Blank",
    onAction: () => {
      // use richtext utils
      editor.execCommand("mceFibBlank");
    },
    enabled: !disableFibBlank,
  });

  (function init() {
    richTextEditor.plugins["fib_blank"] = {
      renderInEditor,
      containPluginElements,
      processOnChange,
      cleanUp,
    };
  })();

  editor.addCommand("mceFibBlank", function () {
    editor.undoManager.transact(function () {
      richTextUtils.insertFibBlankElement(editor);
    });
  });

  function applyBlankPlaceholder(blank, index) {
    const groups = richTextEditor.fibBlankGroups ?? [];
    const group = groups[index] ?? null;
    const baseLabel = `(${index + 1})`;

    blank.setAttribute("value", group && group.label ? `${baseLabel} - ${group.label}` : baseLabel);

    if (group && group.color) {
      blank.classList.add("grouped");
      blank.style.setProperty("--fitb-group-color", group.color);
    } else {
      blank.classList.remove("grouped");
      blank.style.removeProperty("--fitb-group-color");
    }
  }

  function renderInEditor() {
    DOMUtils.elOf(editor.bodyElement, SELECTOR).forEach((blank, index) => {
      applyBlankPlaceholder(blank, index);
      blank.setAttribute("contenteditable", false);
    });
  }
  function cleanUp(content) {
    const container = document.createElement("div");
    container.innerHTML = content;
    const clone = container.cloneNode(true);
    DOMUtils.elOf(clone, SELECTOR).forEach((blank, index) => {
      blank.removeAttribute("contenteditable");
      // Strip editor-only group decorations so grouping never leaks into the
      // saved content (and therefore into the student attempt/view). The blank's
      // canonical persisted value is just its number "(N)"; its only inline style
      // is ever the group colour var, so the whole style attribute can be dropped.
      blank.setAttribute("value", `(${index + 1})`);
      blank.classList.remove("grouped");
      blank.removeAttribute("style");
    });
    return clone.innerHTML;
  }

  function containPluginElements(container) {
    return DOMUtils.elOf(container, "input.fill-in-box").length > 0;
  }

  function processOnChange(editor) {
    processBlankPlaceholder(editor);
  }

  function processBlankPlaceholder(editor) {
    DOMUtils.elOf(editor.bodyElement, SELECTOR).forEach((blank, index) => {
      applyBlankPlaceholder(blank, index);
    });
  }
}
